export const formatCredits = (n) =>
  typeof n === 'number'
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
    : '—';

/**
 * Data-sentinela: plano sem ciclo de assinatura grava um vencimento absurdo
 * (9999-12-31, 2099-12-31). Não é renovação — exibir como "sem expiração"
 * em vez de calcular "em 2912237 dias". O corte de 2 anos não alcança
 * nenhum ciclo real (o maior é anual).
 */
export const isSentinelDate = (value) => {
  if (!value) return false;
  const ts = new Date(value).getTime();
  if (!Number.isFinite(ts)) return false;
  return ts > Date.now() + 2 * 365 * 24 * 60 * 60 * 1000;
};

/**
 * `status = "approved"` significa que o admin aprovou — não que o crédito
 * entrou na conta. Aprovação com cobrança só libera no pagamento da fatura
 * (`releasedAt`). Sem isto a tela mostra chip verde com saldo inalterado.
 */
export const isAwaitingPayment = (row) =>
  row?.status === 'approved' && !row?.releasedAt && row?.fatura?.status !== 'paga';

export const usagePercent = (consumed, total) => {
  if (!total) return 0;
  return Math.min(100, Math.round((consumed / total) * 100));
};

/** Resposta paginada: API usa `count`; legado pode usar `total`. */
export const paginateTotal = (data, listLength = 0) => data?.count ?? data?.total ?? listLength;

/** GET /ai/credits — shape novo (plan/extra/total) com fallback legado. */
export function pickTenantCredits(data) {
  if (!data) return null;
  if (data.plan || data.total) {
    const planIncluded = data.plan?.included ?? data.total?.included ?? 0;
    const planConsumed = data.plan?.consumed ?? 0;
    const planBalance = data.plan?.balance ?? 0;
    const extraBalance = data.extra?.balance ?? 0;
    const totalBalance = data.total?.balance ?? planBalance + extraBalance;
    return {
      totalBalance,
      planIncluded,
      planConsumed,
      planBalance,
      extraBalance,
      periodEndsAt: data.periodEndsAt,
      status: data.status,
      tokens: data.tokens,
    };
  }
  const planIncluded = data.balance ?? 0;
  const extraBalance = typeof data.extra === 'number' ? data.extra : (data.extra?.balance ?? 0);
  return {
    totalBalance: planIncluded + extraBalance,
    planIncluded,
    planConsumed: data.consumedMonth ?? 0,
    planBalance: planIncluded,
    extraBalance,
    periodEndsAt: data.periodEndsAt,
    status: data.status,
    tokens: data.tokens,
  };
}

/** GET /admin/ai/overview — normaliza credits aninhado para colunas da tabela. */
export function normalizeOverviewRow(row) {
  if (!row?.credits) {
    return {
      ...row,
      planBalance: row?.balance,
      planIncluded: row?.total,
    };
  }
  const { credits } = row;
  const planIncluded = credits.plan?.included ?? credits.total?.included ?? 0;
  return {
    ...row,
    balance: credits.total?.balance ?? 0,
    planBalance: credits.plan?.balance ?? 0,
    extra: credits.extra?.balance ?? 0,
    consumed: credits.plan?.consumed ?? 0,
    total: planIncluded,
    planIncluded,
    usagePercent: row.usagePercent ?? usagePercent(credits.plan?.consumed ?? 0, planIncluded),
  };
}

export const companyDisplayName = (row) => row?.Company?.name ?? row?.company?.name;

export const progressColorClass = (pct, classes) => {
  if (pct >= 90) return classes.progressBarColorDanger;
  if (pct >= 80) return classes.progressBarColorWarn;
  return classes.progressBarColorOk;
};
